module.exports = __webpack_public_path__ + "static/media/spinner.e8330294.gif";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/spinner.gif
// module id = 10
// module chunks = 0